import React, { Component } from 'react';
import * as ajax from './../../ajax.js';
import * as lang from './../../lang.js';

import PopUpWindow from './../../components/PopUpWindow';
import { Container, Row, Col, Button } from 'react-bootstrap';

import TextInsertField from './../../components/TextInsertField';
import CheckBoxInsertField from './../../components/CheckBoxInsertField';
import NumberInsertField from './../../components/NumberInsertField';


class UgyfelCimekKarbantartasView extends Component {

    constructor(props) {
        super(props);
        this.state = {
            ugyfelCimek_id: ''
            , ugyfelCimek_ugyfel_id: ''
            , ugyfelCimek_elsodleges: ''
            , ugyfelCimek_irsz: ''
            , ugyfelCimek_telepules: ''
            , ugyfelCimek_cim: ''
            , ugyfelCimek_cim_tipus: ''

        }


        this.references = [];
        this.references['ugyfelCimek_id'] = React.createRef();
        this.references['ugyfelCimek_ugyfel_id'] = React.createRef();
        this.references['ugyfelCimek_elsodleges'] = React.createRef();
        this.references['ugyfelCimek_irsz'] = React.createRef();
        this.references['ugyfelCimek_telepules'] = React.createRef();
        this.references['ugyfelCimek_cim'] = React.createRef();
        this.references['ugyfelCimek_cim_tipus'] = React.createRef();


        this.validators = [];
        this.validators['ugyfelCimek_id'] = {fieldName: 'ugyfelCimek_id', dataType: 'INT', value: this.state.ugyfelCimek_id, mandatory: false, min: null, max: null};
        this.validators['ugyfelCimek_ugyfel_id'] = {fieldName: 'ugyfelCimek_ugyfel_id', dataType: 'INT', value: this.state.ugyfelCimek_ugyfel_id, mandatory: false, min: null, max: null};
        this.validators['ugyfelCimek_elsodleges'] = {fieldName: 'ugyfelCimek_elsodleges', dataType: 'TINYINT', value: this.state.ugyfelCimek_elsodleges, mandatory: false, min: null, max: null};
        this.validators['ugyfelCimek_irsz'] = {fieldName: 'ugyfelCimek_irsz', dataType: 'VARCHAR', value: this.state.ugyfelCimek_irsz, mandatory: false, min: null, max: null};
        this.validators['ugyfelCimek_telepules'] = {fieldName: 'ugyfelCimek_telepules', dataType: 'VARCHAR', value: this.state.ugyfelCimek_telepules, mandatory: false, min: null, max: null};
        this.validators['ugyfelCimek_cim'] = {fieldName: 'ugyfelCimek_cim', dataType: 'VARCHAR', value: this.state.ugyfelCimek_cim, mandatory: false, min: null, max: null};
        this.validators['ugyfelCimek_cim_tipus'] = {fieldName: 'ugyfelCimek_cim_tipus', dataType: 'VARCHAR', value: this.state.ugyfelCimek_cim_tipus, mandatory: false, min: null, max: null};


        this.error = false;
        this.msg = "";

        this.load();

    }

    componentDidUpdate(prevProps) {
        if (prevProps.id !== this.props.id) {
            this.load();
        }
    }

    reset = function () {
        this.setState({ugyfelCimek_id: ''
            , ugyfelCimek_ugyfel_id: ''
            , ugyfelCimek_elsodleges: ''
            , ugyfelCimek_irsz: ''
            , ugyfelCimek_telepules: ''
            , ugyfelCimek_cim: ''
            , ugyfelCimek_cim_tipus: ''
        });
    }

    setBack = function (id, value) {
        this.setState({[id]: value});
    }

    getForm = function () {
        return <Container>
            <Row>
                <Col style={{textAlign: 'left'}}>{lang.getTitleBold('ugyfelCimek_elsodleges')}</Col>
                <Col style={{textAlign: 'right'}}>
                <CheckBoxInsertField 
                    id={'ugyfelCimek_elsodleges'} 
                    value={this.state.ugyfelCimek_elsodleges}  
                    setBack={this.setBack.bind(this)}
                    reference={this.references['ugyfelCimek_elsodleges']}
                    editable={false}
                    theme={this.props.theme}
                    />
                </Col>
            </Row>
            <Row>
                <Col style={{textAlign: 'left'}}>{lang.getTitleBold('ugyfelCimek_irsz')}</Col>
                <Col style={{textAlign: 'right'}}>
                <TextInsertField 
                    id={'ugyfelCimek_irsz'} 
                    value={this.state.ugyfelCimek_irsz}  
                    setBack={this.setBack.bind(this)}
                    reference={this.references['ugyfelCimek_irsz']}
                    editable={false}
                    theme={this.props.theme}
                    style={{width:'100%'}}
                    />
                </Col>
            </Row>
            <Row>
                <Col style={{textAlign: 'left'}}>{lang.getTitleBold('ugyfelCimek_telepules')}</Col>
                <Col style={{textAlign: 'right'}}>
                <TextInsertField 
                    id={'ugyfelCimek_telepules'} 
                    value={this.state.ugyfelCimek_telepules}  
                    setBack={this.setBack.bind(this)}
                    reference={this.references['ugyfelCimek_telepules']}
                    editable={false}
                    theme={this.props.theme}
                    style={{width:'100%'}}
                    />
                </Col>
            </Row>
            <Row>
                <Col style={{textAlign: 'left'}}>{lang.getTitleBold('ugyfelCimek_cim')}</Col>
                <Col style={{textAlign: 'right'}}>
                <TextInsertField 
                    id={'ugyfelCimek_cim'} 
                    value={this.state.ugyfelCimek_cim}  
                    setBack={this.setBack.bind(this)}
                    reference={this.references['ugyfelCimek_cim']}
                    editable={false}
                    theme={this.props.theme}
                    style={{width:'100%'}}
                    />
                </Col>
            </Row>
            <Row>
                <Col style={{textAlign: 'left'}}>{lang.getTitleBold('ugyfelCimek_cim_tipus')}</Col>
                <Col style={{textAlign: 'right'}}>
                <TextInsertField 
                    id={'ugyfelCimek_cim_tipus'} 
                    value={this.state.ugyfelCimek_cim_tipus}  
                    setBack={this.setBack.bind(this)}
                    reference={this.references['ugyfelCimek_cim_tipus']}
                    editable={false}
                    theme={this.props.theme}
                    style={{width:'100%'}}
                    />
                </Col>
            </Row>
        
        </Container>
    }

    closeForm = function () {
        this.reset();
        this.props.closeForm();

    }

    transactionSuccess = function () {
        this.error = false;
        this.msg = lang.getTitleBold('transaction_success');
        this.setState({});
    }

    transactionFail = function (errorStringConstant) {
        this.error = true;
        this.msg = lang.getTitleBold(errorStringConstant);
        this.setState({});
    }

    concatAdditionalParams = function () {
        // var stateClone = JSON.parse(JSON.stringify(this.state));
        if (typeof this.props.additionalParams == 'undefined') {
            return this.state;
        }

        if (this.props.additionalParams == null) {
            return this.state;
        }

        var additionalParams = this.props.additionalParams;
        for (var i = 0; i < additionalParams.length; i++) {
            var additionalParam = additionalParams[i];
            for (const property in additionalParam) {
                this.state[property] = additionalParam[property];
            }
        }
        return this.state;
    }

    

    load = function () {
        var validator = ajax.Validator();
        var validForm = validator.formValidator(this.references, this.validators, this.state);
        if (validForm == false) {
            return false;
        }
        var self = this;
        try {
            const url = ajax.getUrlBase() + "modules/UgyfelCimekKarbantartas/ugyfelCimekFormLoader.php";

            return fetch(url, {
                method: "POST",
                headers: new Headers({"Content-Type": "application/json"}),
                body: JSON.stringify({id: this.props.id})
            }).then(response => {
                if (response.ok) {
                    return response.json().then(response => {
                        if (response.success) {
                            this.setState(response.data[0]);
                        } else {
                            self.transactionFail(response.fail);
                        }

                    }).catch(function (jsonError) {
                        
                        if (null == jsonError) {
                            self.transactionFail('Fetch JSON error');
                            console.error("Fetch JSON error:");
                        } else {
                            self.transactionFail("Fetch JSON error:" + String(jsonError));
                            console.error("Fetch JSON error:" + String(jsonError));
                        }
                    });
                } else {
                    
                    self.transactionFail("HTTP status error:", response.statusText);
                    console.error("HTTP status error:", response.statusText);
                }
            }).catch(function (error) {
                
                self.transactionFail("Fetch error:", error);
                console.error("Fetch error:", error);
                if (null == error) {
                    self.transactionFail("Fetch error:");
                    console.error("Fetch error:");
                } else {
                    self.transactionFail("Fetch error:" + String(error));
                    console.error("Fetch error:" + String(error));
                }
            });
        } catch (ex) {
            
            self.transactionFail("Fetch exception:", String(ex));
            console.error("Fetch exception:", String(ex));
        }
    }

    render() {
        var form = this.getForm();
        var className = (this.props.theme == "true") ? "Dark" : "Light";
        return (<PopUpWindow theme={this.props.theme}>
            <div className={'popupWrapper' + className} id="UgyfelCimekKarbantartasUpdate">
                <div  className={"popupHeader" + className} >
                    <Row>
                        <Col></Col>
                        <Col style={{textAlign: 'center'}}>{lang.getTitleBold('UgyfelCimekKarbantartasView')}</Col>
                        <Col style={{textAlign: 'right'}}>
                        <Button className={'btn-sm'} variant="danger" onClick={this.closeForm.bind(this)}>{lang.getTitle('close')}</Button>
                        </Col>
                    </Row>
                </div>
                <div  className={"popupBody" + className} >{form}</div>
                <div  className={"popupFooter" + className} >
                    <Row>
                        <Col>
                        <div style={{whiteSpace: 'break-spaces'}}>
                            {this.msg} 
                        </div>
        
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                        <Button className={'btn-sm'} id={'save'} onClick={this.closeForm.bind(this)} variant="success" style={{marginTop: '5px'}}>{lang.getTitle('close')}</Button>&nbsp;&nbsp;&nbsp;      
                        </Col>
                    </Row>
                    <Row>
                        <Col style={{minHeight: '10px'}}>
        
                        </Col>
                    </Row>
        
                </div>
            </div>
        </PopUpWindow>);
    }
}

export default UgyfelCimekKarbantartasView;

